import * as echarts from 'echarts';

import {
    NullableNumber,
    ReportItemType,
} from "types/Reports";
import { formatValueAndUnitBasedOnTypeInReport } from "./reportFormat";
import { convertSeriesDataToAdaptMinBarHeight } from './reportConvert';

export const getOverallChartTooltipFormatter = (
    itemType: ReportItemType,
    unit: string,
) => (params: any[]) => {
    if (params.length === 0) {
        return '';
    }

    const getOriginalValue = (param: any) => {
        const original = param.data?.originalValue;

        if (original === undefined) {
            return null;
        }

        return original;
    };

    if (params.length === 1) {
        // cannot use the value because it is normalized
        const value = getOriginalValue(params[0]);

        const valueDisplay = formatValueAndUnitBasedOnTypeInReport(itemType, value, unit, false);

        return `Day ${params[0].dataIndex + 1}: ${valueDisplay}`;
    }

    let tooltip = `Day ${params[0].dataIndex + 1}:`;

    for (const param of params) {
        tooltip += '<br/>';

        // cannot use the value because it is normalized
        const value = getOriginalValue(param);
        const valueDisplay = formatValueAndUnitBasedOnTypeInReport(itemType, value, unit, false);

        tooltip += `- ${param.seriesName}: ${valueDisplay}`;
    }

    return tooltip;
};

export const getOverallUsageChartBase64PNG = (
    {
        itemType,
        chartWidth,
        chartHeight,
        x,
        y,
        color,
        backgroundColor,
    }: {
        itemType: ReportItemType,
        chartWidth: string;
        chartHeight: string;
        x: string[];
        y: NullableNumber[];
        color: string;
        backgroundColor: string;
    },
) => {
    // Create a temporary container
    const container = document.createElement('div');
    container.style.margin = '0';
    container.style.padding = '0';
    container.style.width = chartWidth;
    container.style.height = chartHeight;
    container.style.position = 'absolute';
    container.style.left = '-9999px'; // Hide it from the view
    document.body.appendChild(container);

    // Initialize ECharts
    const chart = echarts.init(container);
    const option: echarts.EChartsOption = {
        title: {
            show: false,
        },
        tooltip: {
            show: false,
        },
        grid: {
            top: 10,
            bottom: 5,
            left: 5,
            right: 5,
            containLabel: true,
        },
        xAxis: {
            data: x,
            axisLabel: {
                fontFamily: 'Roboto',
                fontWeight: 500,
                fontSize: 16,
                color: '#636363',
            },
            axisTick: {
                show: false,
            },
        },
        yAxis: {
            axisLabel: {
                fontFamily: 'Roboto',
                fontWeight: 500,
                fontSize: 16,
                color: '#636363',
            },
        },
        series: [
            {
                type: 'bar',
                // to use barMinHeight attribute, need to handle zero value
                data: convertSeriesDataToAdaptMinBarHeight(itemType, y),
                itemStyle: {
                    color,
                },
                barMinHeight: 1,
            },
        ],
        animation: false,
    };

    chart.setOption(option, true, true);
    chart.resize();

    // Export to base64 PNG
    const base64Image = chart.getDataURL({
        type: 'png',
        pixelRatio: 1,
        backgroundColor,
    });

    chart.dispose();
    container.remove();

    return base64Image;
};
